import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const InputIcon = createIcon({
  displayName: 'InputIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g xmlns="http://www.w3.org/2000/svg" fill="none">
        <path d="M0 0h24v24h-24Z" />
        <path
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20 16h-16c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h16c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11 20h-1c-1.105 0-2-.895-2-2 0 1.105-.895 2-2 2h-1"
        />
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 6v12" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5 4h1c1.105 0 2 .895 2 2 0-1.105.895-2 2-2h1"
        />
      </g>
    </>
  ),
})

const Input: FC<IconProps> = (props) => {
  return <CustomIcon as={InputIcon} {...props} />
}

export default memo(Input)
